(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name main.llicencies.controller:LlicenciesCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main.llicencies')
    .controller('EntitatsMainLlicenciesCtrl', EntitatsMainLlicenciesCtrl);

  function EntitatsMainLlicenciesCtrl(Notification, entitatData, LlicenciaFactory, $locale, HelperFactory, $state, $rootScope, $stateParams, $scope,$mdDialog,$document,EntitatFactory) {
    var vm = this;
    vm.ctrlName = 'EntitatsMainLlicenciesCtrl';

    vm.editLLicencies = editLLicencies;
    vm.add = add;
    vm.saveNewDate = saveNewDate;
    vm.deleteFunction = deleteFunction;
    vm.errors = [];
    //vm.usuarisensessio=usuarisensessio;
    vm.llistar  = llistar;
    vm.isAgrupat=true;
    vm.llicenciesdata = [];

    if(!angular.isUndefined($stateParams.errorproces) && $stateParams.errorproces!='')
    {
      vm.errors.push($stateParams.errorproces);
    }


    function omplirllistalic(){
      vm.llicencies.items = [];
        for (var i=0;i<vm.entitat.llicencies.length;i++){
          if ($locale.localeID === vm.entitat.llicencies[i].idioma){
            vm.llicencies.items.push(vm.entitat.llicencies[i]);
          }
        }
    }

    vm.entitat=entitatData.data;

    var llicencies = [];
    for (var i=0;i<vm.entitat.llicencies.length;i++){
      if ($locale.localeID === vm.entitat.llicencies[i].idioma){
        llicencies.push(vm.entitat.llicencies[i]);
      }
    }
    function llistar(){
     // if (!vm.isAgrupat){
          EntitatFactory.getGroup($stateParams.idEntitat).then(function (response){
            vm.entitat=response.data;
            omplirllistalic();
          }).catch(function(error){
            vm.errors = Notification.processError(error);
          });

     // }
     /* else{
          EntitatFactory.get($stateParams.idEntitat).then(function (response){
            vm.entitat=response.data;
            omplirllistalic();
          }).catch(function(error){
            vm.errors = Notification.processError(error);
          });
      }*/

      
    }

    vm.llicencies = {
      items : llicencies,
      fields : [
        {
          header: 'DEFAULT_NOM',
          type: 'text',
          name: 'productenom'
        },
        {
          header: 'DEFAULT_NUMERO',
          type: 'numeric',
          name: 'numero',
          decimalPlaces:0
         },
        {
          header: 'DEFAULT_DATA_CADUCITAT',
          type: 'multiTransclude',
          block: 'caducitat'
        },
        {
          header: 'DEFAULT_ACCIONS',
          type: 'actions'
        },
        {
          header: 'DEFAULT_USERS',
          type: 'text',
          name: 'usersensessio'
        }
      ]
    };

    function deleteFunction(obj){
      LlicenciaFactory.delete($stateParams.idEntitat,obj.id).then(function(response){
        $scope.$evalAsync(function(){
          vm.llicencies.items.forEach(function(elem, index) {
            if (elem.id === obj.id){
              vm.llicencies.items.splice(index,1);
            }
          });
        });
        Notification.success('GENERIC_SUCCESS');
      }).catch(function(error){
        Notification.processError(error);
      });
    }

    function add(){
      HelperFactory.setParams($stateParams, {'isNew': true});
      $state.go('entitats.main.submain.llicencies.formulari', $stateParams, {'reload': 'entitats.main.submain.llicencies'});
    }

    function editLLicencies(obj){
      HelperFactory.setParams($stateParams, {'isNew': false, 'idLlicencia': obj.id});
      $state.go('entitats.main.submain.llicencies.formulari', $stateParams, {'reload': 'entitats.main.submain.llicencies'});
    }

    function saveNewDate(llicencia){
      LlicenciaFactory.update($stateParams.idEntitat, llicencia.id, llicencia).then(function(response){
        $scope.$evalAsync(function(){
          llicencia.editant = false;
        });
       }).catch(function(error){
        vm.errors = Notification.processError(error);
      });
    }

    if (angular.isUndefined($stateParams.idEntitat) || $stateParams.idEntitat === null || !$stateParams.idEntitat) {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': false});
    }
    else {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': true});
    }

  /*  function usuarisensessio(usuarisensessio) {

      $mdDialog.show({
        controller: function DialogController($scope, $mdDialog,$translate) {
          var vm = this;
          vm.usuarisensessio=usuarisensessio;


          $scope.hide = function() {
            $mdDialog.cancel();
          };
          $scope.cancel = function() {
            $mdDialog.cancel();
          };
        },

        controllerAs: 'ctrl',
        templateUrl: 'entitats/main/llicencies/usuarisensessio.tpl.html',
        parent: angular.element($document.body),
        clickOutsideToClose:true
      });
    }*/

  }
}());
